// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1OHc2","label":"styles_label__3Qhgl"};